import { render, staticRenderFns } from "./TicketCompanyList.vue?vue&type=template&id=3bddb4bf&scoped=true"
import script from "./TicketCompanyList.vue?vue&type=script&lang=js"
export * from "./TicketCompanyList.vue?vue&type=script&lang=js"
import style0 from "./TicketCompanyList.vue?vue&type=style&index=0&id=3bddb4bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddb4bf",
  null
  
)

export default component.exports